const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUBDUED: 'subdued',
  OUTLINE: 'outline',
  PLAIN: 'plain',
  LINK: 'link'
};
const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export { BUTTON_SIZES, BUTTON_VARIANTS };
